import { SET_USER_STATE, DROP_USER_STATE } from '../constants'

const initialState = {
	user: {},
	isAuthenticated: false
};

export const AuthReducer = (state = initialState, action) => {
	switch ( action.type ) {
		case SET_USER_STATE :
			state = {...state, user: action.payload.user, isAuthenticated: true };
			break;
		case DROP_USER_STATE :
			state = {...state, user: action.payload.user, isAuthenticated: false };
			break;
		default :

			break;
	}

	return state;
};


// WEBPACK FOOTER //
// ./src/reducers/auth.js